// This is a modified version of pajasevi/CSSnowflakes code.
// https://github.com/pajasevi/CSSnowflakes

// The MIT License (MIT)
//
// Copyright (c) 2014 Pavel Ševčík
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import { Box, keyframes, styled } from '@mui/material'
import type { FC } from 'react'

import { COLORS, unit } from '@hcr/ui'

export const Snowflakes: FC = () => {
  return (
    <Container>
      <Snowflake />
      <Snowflake />
      <Snowflake />
      <Snowflake />
      <Snowflake />
      <Snowflake />
      <Snowflake />
      <Snowflake />
      <Snowflake />
      <Snowflake />
    </Container>
  )
}

const fall = keyframes`
  100% {
    top: 100%;
  }
`

const shake = keyframes`
  0% {
    transform: translateX(${unit(0)});
  }

  50% {
    transform: translateX(${unit(20)});
  }

  100% {
    transform: translateX(${unit(0)});
  }
`

const Container = styled(Box)`
  color: ${COLORS.white};
  position: absolute;
  height: 100%;
  left: -${unit(3)};
  right: -${unit(3)};
  overflow: hidden;
`

const Snowflake = styled(Box)`
  position: absolute;
  top: -10%;
  font-size: ${unit(4)};
  user-select: none;
  animation:
    ${fall} 12s linear infinite running,
    ${shake} 4s ease-in-out infinite running;

  ::after {
    content: '❅';
  }

  :nth-of-type(0) {
    left: 1%;
    animation-delay: 0s, 0s;
  }

  :nth-of-type(1) {
    left: 10%;
    animation-delay: 1s, 1s;
  }

  :nth-of-type(2) {
    left: 20%;
    animation-delay: 6s, 0.5s;
  }

  :nth-of-type(3) {
    left: 30%;
    animation-delay: 4s, 2s;
  }

  :nth-of-type(4) {
    left: 40%;
    animation-delay: 2s, 2s;
  }

  :nth-of-type(5) {
    left: 50%;
    animation-delay: 8s, 3s;
  }

  :nth-of-type(6) {
    left: 60%;
    animation-delay: 6s, 2s;
  }

  :nth-of-type(7) {
    left: 70%;
    animation-delay: 2.5s, 1s;
  }

  :nth-of-type(8) {
    left: 80%;
    animation-delay: 1s, 0s;
  }

  :nth-of-type(9) {
    left: 90%;
    animation-delay: 3s, 1.5s;
  }
`
